import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const sanityClient = createClient({
    projectId: 'copyy260',
    dataset: 'production',
    apiVersion: '2024-01-01',
    useCdn: true,
});

// Type assertion to fix the fetch signature
export const client = sanityClient as any;

const builder = imageUrlBuilder(client);
export const urlFor = (source: any) => builder.image(source);